module.exports = __webpack_public_path__ + "img/RedteaSIM 1@2x.0f64df36.png";